export const getColumns = () => {
  return [
    {
      'Header': 'Caja',
      'accessor': 'box',
    },
    {
      'Header': 'Nº Pedido',
      'accessor': 'orderNumber',
    },
    {
      'Header': 'Nº Item',
      'accessor': 'line_number',
    },
    {
      'Header': 'Nº Parte',
      'accessor': 'part_code',
    },
    {
      'Header': 'Nombre Parte',
      'accessor': 'partName',
      'width': 300,
    },
    {
      'Header': 'Cant.',
      'accessor': 'part_quantity',
    },
    {
      'Header': 'Precio Unitario',
      'accessor': 'part_unit_price',
    },
    {
      'Header': 'Valor total',
      'accessor': 'amount',
    },
    {
      'Header': 'Peso Neto',
      'accessor': 'weight',
    },
    {
      'Header': 'Peso Total',
      'Cell': ({row}) => {
        return row.original.weight * row.original.part_quantity;
      },
    },
  ];
};
